<template>
    <div :class="'card mb-4 product-card user-card ' + (vg_user.role + '_user_card')">
        <div class="product-card-action">
            <a href="#" class="edit-action" @click.prevent="editcallback(user)">
                <i class="fas fa-pencil-alt"></i>
            </a>
            <a href="#" class="delete-action" @click.prevent="deletecallback(user)">
                <i class="fa fa-trash" aria-hidden="true"></i>
            </a>
        </div>

        <div class="product-card-detail font-weight-bold text-center mt-3">
            <h3 class="mb-0">{{ user.company }}</h3>
            <p class="mb-0">{{ user.user_metas && user.user_metas.complex_building_unit ? user.user_metas.complex_building_unit : '-' }}</p>
            <p class="mb-3">{{ user.address }}</p>
            <img class="mb-3" src="@/assets/images/house.svg" alt="" />
            <p class="mb-0">{{ user.fname }} {{ user.lname }}</p>
            <p class="mb-0">{{ user.email }}</p>
            <p class="mb-0">{{ user.mobile }}</p>
        </div>

        <div class="depot-subitem">
            <ul>
                <li>
                    <router-link
                        class="btn btn-secondary px-3 pt-2"
                        :to="{
                            name: 'SuperadminDistributorProducts',
                            params: {userid: user.id},
                            query: {heading: user.company, page: currentpage, s: s}
                        }"
                        >PRODUCTS</router-link
                    >
                </li>
                <li>
                    <router-link
                        class="btn btn-secondary px-3 pt-2"
                        :to="{
                            name: 'SuperadminDistributorResellers',
                            params: {distributorid: user.id},
                            query: {heading: user.company, page: currentpage, s: s}
                        }"
                        >RESELLER</router-link
                    >
                </li>
                <li>
                    <router-link
                        class="btn btn-secondary px-3 pt-2"
                        :to="{
                            name: 'SuperadminDistributorCustomers',
                            params: {distributorid: user.id},
                            query: {heading: user.company, page: currentpage, s: s}
                        }"
                        >CUSTOMERS</router-link
                    >
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
    name: 'ProductItem',
    props: {
        s: {
            type: String,
            required: false
        },
        currentpage: {
            type: Number,
            required: false
        },
        user: {
            type: Object,
            required: true
        },
        editcallback: {
            type: Function,
            required: true
        },
        deletecallback: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            pdfdata: ''
        };
    },
    computed: {
        ...mapGetters({
            vg_user: 'auth/user'
        })
    },

    mounted() {},
    methods: {
        ...mapActions({
            va_modal: 'pdf/setActive',
            va_modalObj: 'pdf/setActiveObj'
        })
    }
};
</script>
